import styled from "styled-components";
var RelativeContainerOrg = styled.div.withConfig({
  componentId: "sc-1gumyrf-0"
})(["position:relative;"]);
export default RelativeContainerOrg;